// /*
//  * 异步创建script标签
//  */
export default function MapLoader (key) {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=8392e12374515905a3ac458bce8d0283'
      script.onerror = reject
      document.head.appendChild(script)
    }
    window.initAMap = () => {
      resolve(window.AMap)
    }
  })
}
// // 异步引入 高德地图
// export default function loadMap () {
//   return new Promise(function (resolve, reject) {
//     window.init = function () {
//       resolve(AMap)
//     }
//     let script = document.createElement('script')
//     script.type = 'text/javascript'
//     script.async = true
//     script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=8392e12374515905a3ac458bce8d0283'
//     script.onerror = reject
//     document.head.appendChild(script)
//   })
// }



// WEBPACK FOOTER //
// ./src/map/map.js